// handle commas in card names
function splitAtLastComma(str) {
  const lastCommaIndex = str.lastIndexOf(",")
  return [str.substring(0, lastCommaIndex), str.substring(lastCommaIndex + 1)]
}

export const uploadCSV = async (event, setInventory, setName) => {
  const file = event.target.files[0]
  if (file) {
    const text = await file.text()
    // tolerate Windows (CRLF) and classic Mac (CR-only, e.g. Excel's
    // "CSV (Macintosh)" export) line endings, and blank lines
    const rows = text.split(/\r\n|\r|\n/).filter((row) => row.trim() !== "")

    const [headersStr, ...dataStrRows] = rows

    const headers = headersStr ? headersStr.split(",") : []
    if (headers[0] !== "name" || headers[1] !== "count" || headers.length > 2) {
      return window.alert(
        "Invalid CSV file, please provide file generated by the this application."
      )
    }

    const data = dataStrRows.map((row) => {
      const parts = splitAtLastComma(row)
      // this <comma> is also done in the App.js
      //  file when encoding inventory data:
      return [parts[0].replace(/<comma>/g, ","), parseInt(parts[1], 10)]
    })

    for (const el of data) {
      if (typeof el[0] !== "string") {
        return window.alert(
          "File is corrupted, a 'name' field is no longer text."
        )
      }
      if (!Number.isInteger(el[1])) {
        return window.alert(
          "File is corrupted, a 'count' field is no longer an integer."
        )
      }
    }

    const inventory = data.reduce((acc, curr) => {
      acc[curr[0]] = curr[1]
      return acc
    }, {})

    setInventory?.(inventory)
    setName(file.name)
  }
}

export const downloadCSV = (list) => {
  const csvRows = ["name,count", ...list]
  const blob = new Blob([csvRows.join("\n")], { type: "text/csv" })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement("a")
  const currDate = new Date()
  a.setAttribute("hidden", "")
  a.setAttribute("href", url)
  a.setAttribute(
    "download",
    `Grand-Archive-${currDate
      .toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      })
      .replace(/ /g, "-")
      .replace(",", "")}.csv`
  )
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
